import React from "react";
import { ChatInputBox } from "../chat";

const ChatSection = () => {
    return (
        // <div className=" flex-1 flex justify-between">
        <div className="bg-gray-750 flex-1 flex flex-col justify-between font-chat text-gray-200">
            <div className="text-sm text-gray-400 overflow-y-auto">
                <div className="flex mx-6 my-3 py-4  border-t border-gray-700">
                    <div className="flex-none ">
                        <a href="# ">
                            <img
                                src={require("../../assets/dp1.jpg")}
                                alt="avatar"
                                className="w-10 h-10 rounded-full"
                            />
                        </a>
                    </div>
                    <div className="ml-5 px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 rounded">
                        {/* <div>
                                <a
                                    href="# "
                                    className="text-white hover:underline"
                                >
                                    johndoe
                                </a>
                                <span className="text-xs text-gray-600 ml-1">
                                    07/19/2019
                                </span>
                            </div> */}
                        <div>
                            <div>yeah hahaha</div>
                            <div>some other comment</div>
                            <div>why are you so awesome</div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-row-reverse mx-6 my-3 py-4  border-t border-gray-700">
                    <div className="flex-none ml-5">
                        <a href="# ">
                            <img
                                src={require("../../assets/dp1.jpg")}
                                alt="avatar"
                                className="w-10 h-10 rounded-full"
                            />
                        </a>
                    </div>
                    <div className=" px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 rounded">
                        {/* <div>
                                <a
                                    href="# "
                                    className="text-white hover:underline"
                                >
                                    johndoe
                                </a>
                                <span className="text-xs text-gray-600 ml-1">
                                    07/19/2019
                                </span>
                            </div> */}
                        <div>
                            <div>Here are the Tailwind Docs</div>
                        </div>
                    </div>
                </div>

                <div className="flex mx-6 my-3 py-4 border-t border-gray-700">
                    <div className="flex-none">
                        <a href="# ">
                            <img
                                src={require("../../assets/dp1.jpg")}
                                alt="avatar"
                                className="w-10 h-10 rounded-full"
                            />
                        </a>
                    </div>
                    <div className="ml-5 px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 rounded">
                        {/* <div>
                                <a
                                    href="# "
                                    className="text-white hover:underline"
                                >
                                    johndoe
                                </a>
                                <span className="text-xs text-gray-600 ml-1">
                                    07/19/2019
                                </span>
                            </div> */}
                        <div>
                            <div>
                                Does that result in the raw svg being inlined in
                                the DOM?
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex mx-6 my-3 py-4 border-t border-gray-700">
                    <div className="flex-none">
                        <a href="# ">
                            <img
                                src={require("../../assets/dp1.jpg")}
                                alt="avatar"
                                className="w-10 h-10 rounded-full"
                            />
                        </a>
                    </div>
                    <div className="ml-5 px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 rounded">
                        {/* <div>
                                <a
                                    href="# "
                                    className="text-white hover:underline"
                                >
                                    johndoe
                                </a>
                                <span className="text-xs text-gray-600 ml-1">
                                    07/19/2019
                                </span>
                            </div> */}
                        <div>
                            <div>
                                This is handy if you don't want to load SVG as a
                                separate file.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-row-reverse mx-6 my-3 py-4  border-t border-gray-700">
                    <div className="flex-none ml-5">
                        <a href="# ">
                            <img
                                src={require("../../assets/dp1.jpg")}
                                alt="avatar"
                                className="w-10 h-10 rounded-full"
                            />
                        </a>
                    </div>
                    <div className=" px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 rounded">
                        {/* <div>
                                <a
                                    href="# "
                                    className="text-white hover:underline"
                                >
                                    johndoe
                                </a>
                                <span className="text-xs text-gray-600 ml-1">
                                    07/19/2019
                                </span>
                            </div> */}
                        <div>
                            <div>
                                This is handly if You Don't want to load as a
                                separate SVG file
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex mx-6 my-3 py-4 border-t border-gray-700">
                    <div className="flex-none">
                        <a href="# ">
                            <img
                                src={require("../../assets/dp1.jpg")}
                                alt="avatar"
                                className="w-10 h-10 rounded-full"
                            />
                        </a>
                    </div>
                    <div className="ml-5 px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 rounded">
                        {/* <div>
                                <a
                                    href="# "
                                    className="text-white hover:underline"
                                >
                                    johndoe
                                </a>
                                <span className="text-xs text-gray-600 ml-1">
                                    07/19/2019
                                </span>
                            </div> */}
                        <div>
                            <div>Exactly the same way as in Vue impulse</div>
                        </div>
                    </div>
                </div>
                <div className="flex mx-6 my-3 py-4 border-t border-gray-700">
                    <div className="flex-none">
                        <a href="# ">
                            <img
                                src={require("../../assets/dp1.jpg")}
                                alt="avatar"
                                className="w-10 h-10 rounded-full"
                            />
                        </a>
                    </div>
                    <div className="ml-5 px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 rounded">
                        {/* <div>
                                <a
                                    href="# "
                                    className="text-white hover:underline"
                                >
                                    johndoe
                                </a>
                                <span className="text-xs text-gray-600 ml-1">
                                    07/19/2019
                                </span>
                            </div> */}
                        <div>
                            <div>
                                I think it can slow down the page if there's too
                                much bloat in the document.
                            </div>
                            <div>Compared to loading it externally.</div>
                        </div>
                    </div>
                </div>
                <div className="flex mx-6 my-3 py-4 border-t border-gray-700">
                    <div className="flex-none">
                        <a href="# ">
                            <img
                                src={require("../../assets/dp1.jpg")}
                                alt="avatar"
                                className="w-10 h-10 rounded-full"
                            />
                        </a>
                    </div>
                    <div className="ml-5 px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 rounded">
                        {/* <div>
                                <a
                                    href="# "
                                    className="text-white hover:underline"
                                >
                                    johndoe
                                </a>
                                <span className="text-xs text-gray-600 ml-1">
                                    07/19/2019
                                </span>
                            </div> */}
                        <div>
                            <div>
                                Comparison would be better if it's not also
                                comparing an vector svg to a raster gif, it's a
                                difference in rendering too.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ChatInputBox />
        </div>
        // </div>
    );
};

export default ChatSection;
